import * as React from 'react';
interface Props {
  fill: string;
}
export class JoyLogo extends React.PureComponent<Props> {
  static defaultProps = {
    fill: `rgba(0,0,0,.8)`
  };

  render(): React.ReactNode {
    return (
      <svg width="51" height="40" viewBox="0 0 51 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.6263 0L14.049 17.6056C12.5661 20.6223 9.56602 24.2424 5.33009 24.2424C2.29469 24.2424 0.952974 
          23.1422 0 20.7283L2.47116 19.2027C3.28296 20.8348 3.95357 21.4741 5.50656 21.4741C7.87135 21.4741 
          10.1307 18.8473 11.4014 16.1854L17.9315 2.66184L19.2021 0H22.6263Z"
          fill={this.props.fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1276 23.8384C18.3121 23.8384 17.3737 20.9673 17.3737 18.7701C17.3737 13.9504 21.5446 7.67676 
          26.5149 7.67676C29.3994 7.67676 30.303 10.3352 30.303 12.4969C30.303 17.1754 26.7929 23.8384 
          21.1276 23.8384ZM20.202 19.0541C20.202 19.8175 20.235 21.4141 21.4755 21.4141C24.5922 21.4141 
          27.4747 15.8964 27.4747 12.4611C27.4747 11.4201 27.0391 10.101 26.0002 10.101C23.7208 10.101 20.202 14.6819 20.202 19.0541Z"
          fill={this.props.fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.9091 17.2459C46.9319 23.426 39.8997 25.8842 38.5148 26.3056L34.0399 36.1729C32.8325 
          38.8062 30.2757 40 28.18 40C23.8122 40 20.8998 35.5409 23.7762 30.9754C26.4045 26.7971 
          32.5479 25.8135 35.958 24.7256C35.958 24.7256 37.0588 22.7588 38.6213 19.7388C37.1298 21.7055 
          34.8926 23.8824 32.1933 23.8824C29.6005 23.8824 29.6005 21.1086 30.5598 19.1775L36.0285 8.08081H38.9409L33.6492 
          18.7205C33.0816 19.9148 32.939 21.1086 33.8978 21.1086C36.4906 21.1086 40.3258 16.333 41.1786 14.6125C41.1786 14.6125 42.1374 12.5756 44.4456 8.08081H47.3225L39.6511 23.5664C40.4328 23.2855 46.3277 21.0033 49.4532 16.3681L50.9091 17.2459ZM35.5556 27.0707C30.3255 
          28.2514 27.5123 30.3269 26.214 32.8671C25.3844 34.477 26.0697 36.2306 27.6205 36.9103C29.3878 37.6611 31.3719 36.803 32.49 34.2266C32.49 34.2266 32.9588 33.2606 35.5556 27.0707Z"
          fill={this.props.fill}
        />
      </svg>
    );
  }
}
